import { h } from "preact";
import { useEffect, useState } from "preact/hooks";
import uniq from "lodash/uniq";

import MultiSelect from "../MultiSelect.jsx";

export default function MultiselectQuestion(props) {
  const [value, setValue] = useState(
    (typeof props.answer === "string"
      ? props.answer.split(",").filter((x) => x)
      : props.answer) || []
  );

  useEffect(() => {
    setValue(
      (typeof props.answer === "string"
        ? props.answer.split(",").filter((x) => x)
        : props.answer) || []
    );
  }, [props.answer]);

  const items = props.options.suggestions.map((suggestion) =>
    Array.isArray(suggestion)
      ? {
          text: suggestion[0],
          value: suggestion[1],
        }
      : {
          text: suggestion,
          value: suggestion,
        }
  );
  return (
    <MultiSelect
      onlySuggestions={props.options.onlySuggestions}
      label={props.options.label}
      max={props.options.max}
      id="question-multiselect"
      name="answer"
      class="mt-2"
      suggestions={items}
      onChange={(addedValue) => {
        const result = uniq([...value, addedValue]);
        setValue(result);
        props.onSelect(result);
      }}
      onRemove={(removedValue) => {
        const result = value.filter((x) => x != removedValue);
        setValue(result);
        props.onSelect(result);
      }}
      values={value}
    >
      I am initially checked
    </MultiSelect>
  );
}
